// This file ensures that lazy-loaded components are not tree-shaken during production builds
// The imports are type-only to prevent actual code execution
type LazyComponent = () => Promise<any>;

// Import all lazy components
const lazyImports: Record<string, LazyComponent> = {
  Dashboard: () => import('../pages/Dashboard'),
  Profile: () => import('../pages/profile/ProfilePage'),
  Settings: () => import('../pages/settings/SettingsPage'),
  Commissions: () => import('../pages/commissions/CommissionsPage'),
  Tasks: () => import('../components/task/taskCalendar'),
  POS: () => import('../pages/pos/POSPage'),
  JewelryRequest: () => import('../pages/jewelry/JewelryRequestPage'),
  JewelryRequests: () => import('../pages/jewelry-requests/JewelryRequestsPage'),
  RequestLog: () => import('../pages/request-log/RequestLogPage'),
  InteractionLog: () => import('../pages/interactions/InteractionLogPage'),
  LogInteraction: () => import('../pages/interactions/LogInteractionPage'),
  Reports: () => import('../pages/reports/ReportsPage'),
  Marketing: () => import('../pages/marketing/MarketingPage'),
  ContentCalendar: () => import('../pages/marketing/ContentCalendar'),
  UserManagement: () => import('../pages/admin/UserManagement')
};

// Force Vite to include these modules in the build
export const preloadComponents = () => {
  Object.values(lazyImports).forEach(importFn => {
    // We don't actually execute the imports, just reference them
    void importFn;
  });
};

// Export the record of imports for potential use elsewhere
export default lazyImports; 